import {FC} from "react";
import {Skeleton} from "@mui/material";

export const BlockSkeletonExperts: FC = () => {
  return (
    <div
      style={{
        marginTop: 15,
        display: "flex",
        alignItems: "start",
        justifyContent: "start",
        gap: 10,
      }}
    >
      <div>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={60}
          height={60}
          sx={{
            backgroundColor: "#4E5574",
            borderRadius: 0.8,
            "&::after": {
              background:
                "linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.3),transparent)",
              opacity: 1,
              transform: "skewX(-10deg)",
            },
          }}
        />
      </div>
      <div style={{display: "flex", flexDirection: "column", gap: 5}}>
        <Skeleton
          animation="wave"
          variant="rectangular"
          height={10}
          width={160}
          sx={{
            backgroundColor: "#4E5574",
            borderRadius: 0.8,
            width: "100%",
            "&::after": {
              background:
                "linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.3),transparent)",
              opacity: 1,
              transform: "skewX(-10deg)",
            },
          }}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          height={30}
          width={400}
          sx={{
            backgroundColor: "#4E5574",
            borderRadius: 0.8,
            width: "100%",
            "&::after": {
              background:
                "linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.3),transparent)",
              opacity: 1,
              transform: "skewX(-10deg)",
            },
          }}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          height={10}
          width={260}
          sx={{
            backgroundColor: "#4E5574",
            borderRadius: 0.8,
            width: "100%",
            "&::after": {
              background:
                "linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.3),transparent)",
              opacity: 1,
              transform: "skewX(-10deg)",
            },
          }}
        />
      </div>
    </div>
  );
};

export const BlockSkeletonOrganization: FC = () => {
  return (
    <div
      style={{
        marginTop: 15,
        display: "flex",
        alignItems: "start",
        justifyContent: "start",
        gap: 10,
      }}
    >
      <div>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={15}
          height={15}
          sx={{
            backgroundColor: "#4E5574",
            borderRadius: 0.8,
            "&::after": {
              background:
                "linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.3),transparent)",
              opacity: 1,
              transform: "skewX(-10deg)",
            },
          }}
        />
      </div>
      <div style={{display: "flex", flexDirection: "column", gap: 5}}>
        <Skeleton
          animation="wave"
          variant="rectangular"
          height={15}
          width={160}
          sx={{
            backgroundColor: "#4E5574",
            borderRadius: 0.8,
            width: "100%",
            "&::after": {
              background:
                "linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.3),transparent)",
              opacity: 1,
              transform: "skewX(-10deg)",
            },
          }}
        />
        <div style={{height: 15}}></div>
        <Skeleton
          animation="wave"
          variant="rectangular"
          height={15}
          width={400}
          sx={{
            backgroundColor: "#4E5574",
            borderRadius: 0.8,
            width: "100%",
            "&::after": {
              background:
                "linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.3),transparent)",
              opacity: 1,
              transform: "skewX(-10deg)",
            },
          }}
        />

        <Skeleton
          animation="wave"
          variant="rectangular"
          height={15}
          width={400}
          sx={{
            backgroundColor: "#4E5574",
            borderRadius: 0.8,
            width: "100%",
            "&::after": {
              background:
                "linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.3),transparent)",
              opacity: 1,
              transform: "skewX(-10deg)",
            },
          }}
        />

        <Skeleton
          animation="wave"
          variant="rectangular"
          height={15}
          width={400}
          sx={{
            backgroundColor: "#4E5574",
            borderRadius: 0.8,
            width: "100%",
            "&::after": {
              background:
                "linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.3),transparent)",
              opacity: 1,
              transform: "skewX(-10deg)",
            },
          }}
        />
        <div style={{height: 15}}></div>
        <Skeleton
          animation="wave"
          variant="rectangular"
          height={20}
          width={260}
          sx={{
            backgroundColor: "#4E5574",
            borderRadius: 0.8,
            width: "100%",
            "&::after": {
              background:
                "linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.3),transparent)",
              opacity: 1,
              transform: "skewX(-10deg)",
            },
          }}
        />
      </div>
    </div>
  );
};
